export default {
  PAGINATION: 'pagination',
  NAVIGATION_BUTTONS: 'navigation-buttons',
  AUTO_CHANGE: 'auto-change',
  INITIAL_SLIDE_INDEX: 'initial-slide-index',
  TRANSITION_TYPE: 'transition-type',
  AUTO_CHANGE_DELAY: 'auto-change-delay',
};
